import { useEffect, useRef } from 'react';
/**
 * Wrapper hook for useEffect, won't fire effect on init, only on deps changes
 * @param {EffectCallback} effect – Imperative function that can return a cleanup function
 * @param {DependencyList} deps - effect will only activate if the values in the list change.
 * */
export const useUpdateEffect = (effect, deps) => {
    const isInitialMount = useRef(true);
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        }
        else {
            effect();
        }
    }, deps);
};
//# sourceMappingURL=useUpdateEffect.js.map